"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _R2Plugin = /*#__PURE__*/ _interop_require_default(require("./R2Plugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _R2Plugin.default,
    id: 'cloudflare-r2',
    title: 'Cloudflare R2',
    recoveryTitle: 'Cloudflare R2 Storage',
    version: '0.0.3',
    logo: 'plugins/r2.png',
    description: 'Cloudflare R2 is an S3-compatible, zero egress-fee, globally distributed object storage.',
    tags: 'Storage',
    inputs: {
        title: 'Configure Cloudflare R2 Storage',
        items: [
            {
                key: 'bucket',
                label: 'Bucket Name',
                placeholder: 'Bucket Name',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'hostname',
                label: 'Host Name',
                placeholder: 'e.g.: *****.r2.cloudflarestorage.com',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_key',
                label: 'Access Key',
                placeholder: 'Access Key',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_secret',
                label: 'Access Secret',
                placeholder: 'Access Secret',
                type: _nocodbsdk.XcType.Password,
                required: true
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully configured! Attachments will now be stored in Cloudflare R2 Storage.',
        msgOnUninstall: ''
    },
    category: 'Storage'
};
const _default = config;
